import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SUB_CATEGORIES_SUB_CATEGORY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/sub-categories',
        name: '::Menu:SubCategories',
        iconClass: 'fas fa-folder-open',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.SubCategories',
        parentName: '::Menu:Configurations',
        order: 4,
      },
    ]);
  };
}
